import styled from 'styled-components';

export const StyledForm = styled.form<{ $gap: string }>`
   display: flex;
   flex-direction: column;
   gap: ${(props) => props.$gap};
`;

StyledForm.displayName = 'StyledForm';
